import script from "./AiPromptDataForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AiPromptDataForm.vue?vue&type=script&setup=true&lang=js"

import "./AiPromptDataForm.vue?vue&type=style&index=0&id=a396615c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a396615c"]])

export default __exports__